





























































import Vue from 'vue';
import UserPage from '../components/UserPage.vue';
import UserFormField from '../components/UserFormField.vue';
import gtInit from '@/common/utils/Gt';
import userClient from '../apis';
import { Scene } from '../models/SmsVerify';
import { Source } from '../models/Login';

const email: string | null = null;
const password: string | null = null;
const mobile: string | null = null;
const code: string | null = null;
const captchaObj: any | null = null;

export default Vue.extend({
  components: {
    UserPage,
    UserFormField,
  },
  data() {
    return {
      email,
      password,
      mobile,
      code,
      showWarning: false,
      warningText: '',
      sendedVerifyCode: false,
      gtCapValid: '',
      initGeetest: false,
      inited: false,
      emailHadRegister: false,
      mobileHadRegister: false,
      gtInit,
      isSending: false,
      sendingText: '',
      registering: false,
      registerSuccess: false,
      agree: false,
      captchaObj,
    };
  },
  methods: {
    sendVerifyCode() {
      if (!this.validateMobile(this.mobile)) {
        this.$Message.error('请输入正确的手机号码');
      } else {
        userClient.checkMobileRegister({
          mobile: this.mobile,
        }).success((r) => {
          if (r) {
            this.mobileHadRegister = true;
            this.warningText = '该号码已经被注册，请直接登录';
          } else {
            this.mobileHadRegister = false;
            this.captchaObj.verify();
          }
        });
      }
    },
    sendSmsCode() {
      userClient.sendSmsCode({
        mobile: this.mobile,
        scene: Scene.UserRegister,
      }).success(() => {
        this.countDown(300);
      });
    },
    confirmRegister() {
      if (this.validateForm()) {
        this.registering = true;
        userClient.register({
          email: this.email,
          mobile: this.mobile,
          password: this.password,
          code: this.code,
          source: Source.Crm,
        }).success((r) => {
          switch (r.errorCode) {
            case 0:
              this.registerSuccess = true;
              setTimeout(window.location.href = '#/user/auth', 3000);
              break;
            case 1001: 
              this.showWarning = true;
              this.warningText = '手机验证码错误';
              break;
            default: 
              this.showWarning = true;
              this.warningText = '系统错误，请刷新重试';
          }
          this.registering = false;
        });
      }
    },
    countDown(remain: number) {
      this.sendedVerifyCode = true;
      const downCountInterval = setInterval(() => {
        remain -= 1;
        if (remain <= 0) {
          clearInterval(downCountInterval);
          this.sendedVerifyCode = false;
        } else {
          this.sendingText = '重新发送（' + remain + '）';
        }
      }, 1000);
    },
    validateForm() {
      if (this.email === null || this.email === '') {
        this.showWarning = true;
        this.warningText = '请输入邮箱';
        return false;
      }
      if (!this.validateEmail(this.email)) {
        this.showWarning = true;
        this.warningText = '请输入格式正确的邮箱';
        return false;
      }
      if (this.emailHadRegister) {
        this.showWarning = true;
        this.warningText = '该邮箱已经注册，请直接登录';
        return false;
      }
      if (this.password === null || this.password === '') {
        this.showWarning = true;
        this.warningText = '请输入密码';
        return false;
      }
      if (!this.validatePassword(this.password)) {
        this.showWarning = true;
        this.warningText = '请输入6到16位密码，区分大小写';
        return false;
      }
      if (this.mobile === null || this.mobile === '') {
        this.showWarning = true;
        this.warningText = '请输入手机号';
        return false;
      }
      if (!this.validateMobile(this.mobile)) {
        this.showWarning = true;
        this.warningText = '请输入格式正确的手机号';
        return false;
      }
      if (this.code === null || this.code === '') {
        this.showWarning = true;
        this.warningText = '请输入验证码';
        return false;
      }
      if (isNaN(this.code as any) || this.code.length > 4) {
        this.showWarning = true;
        this.warningText = '请输入格式正确的验证码';
        return false;
      }
      if (!this.agree) {
        this.showWarning = true;
        this.warningText = '请阅读并同意使用协议';
        return false;
      }
      this.showWarning = false;
      return true;
    },
    checkEmailRegister() {
      if (this.validateEmail(this.email)) {
        userClient.checkEmailRegister({
          email: this.email,
        }).success((r) => {
          if (r) {
            this.emailHadRegister = true;
          } else {
            this.emailHadRegister = false;
          }
        });
      }
    },
    validateEmail(email: string | null) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return email !== null && re.test(email);
    },
    validatePassword(password: string | null) {
      // const re = /(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*])[a-z\d#@!~%^&*]{6,16}/i;
      // return password != null && re.test(password);
      return password.length >= 6 && password.length <= 16;
    },
    validateMobile(mobile: string | null) {
      const re = /^(13\d|14[^23\D]|15\d|16[2567]|17[^9\D]|18\d|19[189])\d{8}$/;
      return mobile !== null && re.test(mobile);
    },
    redirectIfIE() {
      function checkIE() {
        return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
      }
      if (checkIE()) {
        window.location.href = '/not-supported';
      }
    },
    initGtCaptcha() {
      /* eslint-disable */
      const that = this;
      userClient
        .getGtCaptcha()
        .success((res) => {
          (window as any).initGeetest({
            gt: res.gt,
            challenge: res.challenge,
            offline: !res.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: true, // 用于宕机时表示是新验证码的宕机
            product: 'bind',
            width: '260px',
          }, function(captchaObj: any) {
            captchaObj.onReady(function() {
              that.inited = true;
              that.initGeetest = true;
              that.captchaObj = captchaObj;
            }).onSuccess(function() {
              that.sendSmsCode();
            }).onError(function() {
              that.$Message.error('出错啦，请刷新页面进行重试');
            });
          });
        }).error((e) => {
          that.inited = true;
        });
    },
  },
  mounted() {
    this.redirectIfIE();
    this.initGtCaptcha();
  },
});
